import React, { useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { SetCanSaveEditOrder } from "../../../../../../Redux/actions/actionNames";

const App = () => {
  const dispatch = useDispatch();

  // ================= STATE =================
  const price = useSelector((state) => state.NewOrder.newOrder.price);

  const pickup = useSelector((state) => state.EditOrder.editOrder.pickup);
  const firstDropOff = useSelector(
    (state) => state.EditOrder.editOrder.dropOffs.firstDropOff
  );

  const orderCustomFieldDefinitions = useSelector(
    (state) => state.ViewTravel.pureData?.customFieldDefinitions
  );

  const deliveryMethodSetting = useSelector(
    (state) => state.ViewTravel.pureData.deliveryMethod?.setting
  );

  const pickupCustomFields = useSelector(
    (state) => state.EditOrder.editOrder.pickup.customField || {}
  );

  const firstDropOffCustomFields = useSelector(
    (state) =>
      state.EditOrder.editOrder.dropOffs.firstDropOff.customFields || {}
  );

  // ================= HELPERS =================

  const emailValidate = useCallback((email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }, []);

  const orderCustomFieldCheck = useCallback(() => {
    let boollx = true;
    let boolly = true;

    orderCustomFieldDefinitions
      ?.filter((item) => item.stage === "pickup" && item.isRequired)
      .forEach((item) => {
        if (!pickupCustomFields[item.key]) boollx = false;
      });

    firstDropOff?.customFieldDefinitions
      ?.filter((item) => item.stage === "dropoff" && item.isRequired)
      .forEach((item) => {
        if (!firstDropOffCustomFields[item.key]) boolly = false;
      });

    return boollx && boolly;
  }, [
    orderCustomFieldDefinitions,
    pickupCustomFields,
    firstDropOff,
    firstDropOffCustomFields,
  ]);

  const pickupRequiredCheck = useCallback(() => {
    if (!deliveryMethodSetting) return false;

    const name = deliveryMethodSetting.isPickupAddressNameRequired
      ? pickup.fullName?.trim()?.length > 0
      : true;

    const phone = deliveryMethodSetting.isPickupAddressPhoneRequired
      ? pickup.phone?.trim()?.length > 3
      : true;

    const email = deliveryMethodSetting.isPickupAddressEmailRequired
      ? pickup.email &&
        pickup.email.length > 0 &&
        emailValidate(pickup.email)
      : true;

    return name && phone && email;
  }, [deliveryMethodSetting, pickup, emailValidate]);

  const firstDropOffRequiredCheck = useCallback(() => {
    if (!deliveryMethodSetting) return false;

    const name = deliveryMethodSetting.isDropoffAddressNameRequired
      ? firstDropOff.fullName?.trim()?.length > 0
      : true;

    const phone = deliveryMethodSetting.isDropoffAddressPhoneRequired
      ? firstDropOff.phone?.trim()?.length > 3
      : true;

    const email = deliveryMethodSetting.isDropoffAddressEmailRequired
      ? firstDropOff.email &&
        firstDropOff.email.length > 0 &&
        emailValidate(firstDropOff.email)
      : true;

    return name && phone && email;
  }, [deliveryMethodSetting, firstDropOff, emailValidate]);

  // ================= Lifecycle (جایگزین componentWillReceiveProps) =================

  useEffect(() => {
    console.log(
      "fcaeassfesd",
      pickupRequiredCheck(),
      orderCustomFieldCheck(),
      firstDropOffRequiredCheck()
    );

    const canSave =
      price?.done &&
      pickupRequiredCheck() &&
      orderCustomFieldCheck() &&
      firstDropOffRequiredCheck();

    dispatch(SetCanSaveEditOrder(!!canSave));
  }, [
    price,
    pickupRequiredCheck,
    orderCustomFieldCheck,
    firstDropOffRequiredCheck,
    dispatch,
  ]);

  return null;
};

export default App;
